<template>
	<div class="table-responsive">
		<table class="table table-row-bordered">
			<thead>
				<tr class="fw-bold fs-6">
					<th>Nome</th>
					<th>Data de instalação</th>
					<th>Fabricante</th>
					<th>Versão</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(software, index) in computer_softwares"
					:key="index">
					<td>{{ software.name }}</td>
					<td>{{ software.install_date }}</td>
					<td>{{ software.publisher }}</td>
					<td>{{ software.version }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script setup lang="ts">
	interface Software {
		install_date: string;
		publisher: string;
		version: string;
		name: string;
	}

	const props = defineProps({
		softwares: { type: Array, required: true },
	});

	const computer_softwares = props.softwares as Array<Software>;

	computer_softwares.forEach((software) => {
		if (software.install_date != '' && software.install_date.length === 8) {
			const date = software.install_date.replace(
				/(\d{4})(\d{2})(\d{2})/,
				'$1-$2-$3'
			);
			software.install_date = new Date(date).toLocaleDateString();
		}
	});
</script>
